import { getCategoryFromTree } from "~/composables/ExpApi/expCategory";
import { useCurrentStore, gtmDataContainer, useFlagsUsedState } from "~/composables/states";
import { v4 as uuidv4 } from "uuid";
import { getExpNavigationTree } from "./ExpApi/expCache";

export function fillGtmDataLayer(product: any, impressionList?: any) {
	if (product) {
		gtmDataContainer().value.ecommerce.detail.products = [product];
	}
	if (impressionList) {
		for (let b = 0; b < impressionList.length; b++) {
			gtmDataContainer().value.ecommerce.impressions.push(impressionList[b]);
		}
	}
}

export function checkTenParents(target, attribute: string) {
	let x = 0;
	let parent = target?.parentElement;
	while (x < 10 && !parent?.getAttribute(attribute)) {
		parent = parent?.parentElement;
		x++;
	}
	return parent?.getAttribute(attribute);
}

export async function getImpressionsForDataLayer(bundle: Array<Object>, list_name?: string) {
	console.log("getImpressionsForDataLayer : ", bundle, list_name);
	let container = new Array();
	if (bundle !== undefined && bundle.length !== undefined) {
		for (let a = 0; a < bundle.length; a++) {
			let ob: DLItem = {
				item_id: '',
				item_name: '',
				item_list_name: '',
				item_brand: '',
				item_category: '',
				index: 0,
				price: 0,
				priceNet: 0,
				id_branch_id: '',
				item_ean: '',
				item_mpn: '',
			};
			ob.item_id = bundle[a].id;
			ob.item_name = bundle[a]?.expArticle?.title;
			ob.item_list_name = list_name ?? "PPM";
			ob.item_brand = bundle[a].brand;
			// let categoryList = await getArticleCategoriesList(bundle[a]?.expArticle?.primaryCategory);
			// if(categoryList !== undefined && categoryList?.value?.list.length > 0) {
			// 	let array = categoryList?.value?.list
			// 	let primaryCategory = array[array.length-1].name
			// 	ob.category = primaryCategory
			// }
			const cat = await getCategoryFromTree(bundle[a]?.expArticle?.primaryCategory);
			const catString = cat?.ancestors?.replace(", ", "/") + "/" + cat?.name;

			ob.item_category = catString?.split('/')?.at(0);
			ob.item_category2 = catString?.split('/')?.at(1);
			ob.item_category3 = catString?.split('/')?.at(2);

			ob.index = gtmGlobalCounter().value;
			ob.price = bundle[a]?.price;
			ob.priceNet = bundle[a]?.expPrice?.nettoPrice;
			ob.id_branch_id = bundle[a]?.id + "_" + useCurrentStore().value?.id;
			ob.item_ean = bundle[a]?.expArticle?.internationalArticleNumber;
			ob.item_mpn = bundle[a]?.expArticle?.manufacturerPartNumber;

			container.push(ob);
			gtmGlobalCounter().value++;
		}
	}
	console.log("getImpressionsForDataLayer :CONTAINER ", container);
	if (useDevice()?.isCrawler == false) {
		onConsented(() => {
			useGtm()?.trackEvent({
				event: "view_item_list",
				value: {
					item_list_name: list_name,
					items: container
				}
			})
		})
	}
	// fillGtmDataLayer(false, container);
}

export const useGeneralTrick = (event: any, to?: any) => {
	const finalEvent = createGeneralTickingData(event, to);
	if (useDevice()?.isCrawler == false) {
		checkForGTMTracking(finalEvent);
	}
	// useState('generalTicking').value = finalEvent;
	// console.debug("[gta] got event", finalEvent);
	const params = {
		method: "POST",
		body: {
			// entry: {
			sessionId: event.sessionId,
			eventType: event.eventType,
			tickId: finalEvent?.tickId,
			json: JSON.stringify(finalEvent),
			// },
		},
		credentials: "include"
	};
	// if (finalEvent?.eventType != 'VIEW_ITEM') {
	// if (useNuxtApp().isHydrating) {
	// 	console.warn('useFetch for Tracking')
	// 	return useFetch(useRuntimeConfig().public.apiUrl + "/api/generalTrick/tick", { body: params.body, method: "POST", credentials: "include", onRequestError: params.onRequestError, onResponse: params.onResponse });
	// } else {
	// console.warn('$fetch for Tracking')
	return $fetch(useRuntimeConfig().public.apiUrl + "/api/generalTrick/tick", { body: params.body, method: "POST", referrerPolicy: "origin", credentials: "include", onRequestError(err) { console.debug("[bt-gta] got request-error", err?.error, err?.response); } })
	// }
	// }
};

export const stillWaitingForConsent = () => useState<boolean>('waitingForConsent', () => true);

export const onConsented = (callbackFn: Function) => {
	onNuxtReady(() => {
		if (stillWaitingForConsent().value)
			window.addEventListener("CookiebotOnConsentReady", (_ev) => callbackFn());
		else
			callbackFn()
	})
}

export const consented = () => {
	stillWaitingForConsent().value = false;
}

function checkForGTMTracking(finalEvent: any) {
	const logger = useLogger('checkForGTMTracking');
	onConsented(() => {
		if (finalEvent?.eventType == 'VIEW_ITEM') {
			logger.info('got View Item Event, sending via gtm');
			// useGtm()?.dataLayer()?.push();  // Clear the previous ecommerce object.
			let ob: DLItem = {
				item_id: "",
				item_name: "",
			};
			ob.item_id = finalEvent?.json?.item;
			ob.item_name = finalEvent?.json?.name;
			ob.item_brand = finalEvent?.json?.brand;
			ob.item_category = finalEvent?.json?.category;
			ob.price = finalEvent?.json?.price;
			ob.priceNet = finalEvent?.json?.priceNet;
			ob.quantity = finalEvent?.json?.quantity;
			ob.id_branch_id = finalEvent?.json?.item + "_" + finalEvent?.storeId;
			ob.location_id = finalEvent?.storeId;
			ob.item_ean = finalEvent?.json?.ean;
			ob.item_mpn = finalEvent?.json?.mpn;
			useGtm()?.trackEvent({
				event: "view_item",
				event_id: finalEvent?.tickId,
				event_timestamp: finalEvent?.tickTs,
				bt_session: useCurrentSessionIdentifier()?.value,
				bt_ident: useExpCookieIdentifier()?.value,
				ecommerce: {
					currency: 'EUR',
					value: finalEvent?.json?.price,
					items: [ob]
				}
			})

		} else if (finalEvent?.eventType == 'VIEW_PAGE' && (finalEvent?.json?.content?.startsWith('Checkout') || finalEvent?.json?.content?.startsWith('Reservation') || finalEvent?.url?.startsWith('/shop/checkout') || finalEvent?.json?.url?.at(0)?.includes('checkout'))) {
			logger.debug('got Checkout Step Event, sending via gtm', finalEvent?.json?.content, finalEvent);
			// useGtm()?.dataLayer()?.push({ ecommerce: null });  // Clear the previous ecommerce object.
			let items = finalEvent?.json?.cart?.itemList?.map(itemToGTM)
			if (finalEvent?.json?.step == "1") {
				useGtm()?.trackEvent({
					event: "begin_checkout",
					event_id: finalEvent?.tickId,
					event_timestamp: finalEvent?.tickTs,
					bt_session: useCurrentSessionIdentifier()?.value,
					bt_ident: useExpCookieIdentifier()?.value,
					ecommerce: {
						actionField: {
							affiliation: finalEvent?.json?.content?.startsWith('Reservation') ? 'Store Reservation' : 'Online Store',
						},
						currency: "EUR",
						value: finalEvent?.json?.cart?.subTotalBill,
						items: items
					}
				})
			} else if (finalEvent?.json?.step == "2" || finalEvent?.json?.step == "3") {
				useGtm()?.trackEvent({
					event: "add_shipping_info",
					event_id: finalEvent?.tickId,
					event_timestamp: finalEvent?.tickTs,
					bt_session: useCurrentSessionIdentifier()?.value,
					bt_ident: useExpCookieIdentifier()?.value,
					ecommerce: {
						actionField: {
							affiliation: finalEvent?.json?.content?.startsWith('Reservation') ? 'Store Reservation' : 'Online Store',
						},
						currency: "EUR",
						value: finalEvent?.json?.cart?.subTotalBill,
						items: items
					}
				})
			} else if (finalEvent?.json?.step == "4") {
				useGtm()?.trackEvent({
					event: "add_payment_info",
					event_id: finalEvent?.tickId,
					event_timestamp: finalEvent?.tickTs,
					bt_session: useCurrentSessionIdentifier()?.value,
					bt_ident: useExpCookieIdentifier()?.value,
					ecommerce: {
						actionField: {
							affiliation: finalEvent?.json?.content?.startsWith('Reservation') ? 'Store Reservation' : 'Online Store',
						},
						payment_type: finalEvent?.json?.paymentChannel,
						currency: "EUR",
						value: finalEvent?.json?.cart?.subTotalBill,
						items: items
					}
				})
			}
		} else if (finalEvent?.eventType == 'ADD_TO_CART_ITEM') {
			logger.debug('got Add To Cart Event, sending via gtm', finalEvent);
			useGtm()?.trackEvent({
				event: "add_to_cart",
				event_id: finalEvent?.tickId,
				event_timestamp: finalEvent?.tickTs,
				bt_session: useCurrentSessionIdentifier()?.value,
				bt_ident: useExpCookieIdentifier()?.value,
				ecommerce: {
					actionField: {
						affiliation: finalEvent?.json?.cartType == 'RESERVATION_CART' ? 'Store Reservation' : 'Online Store',
					},
					payment_type: finalEvent?.json?.paymentChannel,
					currency: "EUR",
					value: finalEvent?.json?.cart?.subTotalBill,
					items: [itemToGTM({ articleId: finalEvent?.json?.articleId, quantity: finalEvent?.json?.quantity })]
				}
			})
		} else if (finalEvent?.eventType == 'VIEW_PAGE') {
			useGtm()?.trackEvent({
				event: "page_view",
				event_id: finalEvent?.tickId,
				event_timestamp: finalEvent?.tickTs,
				bt_session: useCurrentSessionIdentifier()?.value,
				bt_ident: useExpCookieIdentifier()?.value,
				page_location: finalEvent?.json?.url?.at(0)?.at(0),
				page_referrer: finalEvent?.json?.refferer
			})
		}
	})
}

export function itemToGTM(item): DLItem {
	console.debug('mapping item', item)
	try {
		let article = toRaw(useNuxtData('article/id=' + item?.articleId)?.data?.value);
		if (!article?.name) {
			let pdsDatas = Object.keys(useNuxtApp()?.payload?.data || {})?.filter(a => a?.startsWith('articlepds'))?.map(ob => useNuxtData(ob));
			article = toRaw(pdsDatas?.find(da => da?.data?.value?.article?.articleId == item?.articleId)?.data?.value?.article);
		}
		const brand = toRaw(useNuxtData('brand/id=' + article?.brandId)?.data?.value);
		// const primCat = Array.from(getExpNavigationTree('MAIN')?.data?.value)?.flatMap(ca => ca?.descendants)?.flatMap(ca => ca?.descendants)?.find(cat => cat?.extId == article?.primaryCategory);
		const primCat = toRaw(getExpNavigationTree('MAIN')?.data?.value?.flatMap(ca => ca?.descendants)?.flatMap(ca => ca?.descendants)?.find(cat => cat?.extId == article?.primaryCategory));
		let gtmItem: DLItem = {
			item_name: item?.name || article?.name,
			item_brand: brand?.name,
			item_id: article?.webcode,
			price: item?.price?.gross ?? item?.pubData?.price?.gross,
			priceNet: item?.price?.net ?? item?.pubData?.price?.net,
			currency: 'EUR',
			quantity: item?.quantity ?? item.amount,
			item_category: primCat?.name,
			item_category2: primCat?.ancestors?.split(', ')?.at(0),
			item_category3: primCat?.ancestors?.split(', ')?.at(1),
			item_variant: article?.variationId,
			id_branch_id: item?.articleId + '_' + useCurrentStore()?.value?.id,
			location_id: useCurrentStore()?.value?.id,
			item_ean: article?.internationalArticleNumber,
			item_mpn: article?.manufacturerPartNumber
		}
		return gtmItem;

	} catch (error) {
		console.warn('could not map itemToGTM', error);
		return item;
	}
}


interface DLItem {
	item_id: string;
	item_name: string;
	affiliation?: string;
	coupon?: string;
	discount?: number;
	index?: number;
	item_ean?: string;
	item_mpn?: string;
	item_brand?: string;
	item_category?: string;
	item_category2?: string;
	item_category3?: string;
	item_list_id?: string; // eg. "related_articles"
	item_list_name?: string; // eg. "Related Articles"
	item_variant?: string; // id or name
	location_id?: string;
	id_branch_id?: string;
	price?: number;
	priceNet?: number;
	currency?: string;
	quantity?: number;
}

export function sendUiStateToSearchEvent(uiState, user) {
	// console.debug("[bt-gta] useUiStateToSearchEvent", uiState, user);
	return useGeneralTrick({
		eventType: "VIEW_SEARCH_RESULT",
		sessionId: user?.sessionIdentifier,
		json: {
			search: [uiState?.query, uiState?.totalHits],
			usertype: "unknownUser",
			langid: 'userbotscore=' + useABConfigCookie()?.value?.context?.userbotscore,
			countryid: user?.client,
			content: useRoute().path,
			url: [[useRoute().fullPath]],
			redirectedFrom: useRoute().redirectedFrom,
			sfilter: [["queryType", uiState?.queryType]],
			refinements: uiState?.refinementList,
			configure: uiState?.configure,
			sortBy: uiState?.sortBy,
			processingTimeMS: uiState?.processingTimeMS,
		},
	});
}

export function middleware(instantSearchInstance) {
	return {
		onStateChange({ uiState }) {
			// console.debug("ui state changed, send event", uiState, instantSearchInstance);
			if (uiState[useReactiveSearchCreds().reactiveBaseAppName]) {
				uiState[useReactiveSearchCreds().reactiveBaseAppName].totalHits =
					instantSearchInstance.renderState?.[useReactiveSearchCreds().reactiveBaseAppName].hits.results.nbHits;
				uiState[useReactiveSearchCreds().reactiveBaseAppName].queryType =
					instantSearchInstance.renderState?.[useReactiveSearchCreds().reactiveBaseAppName].hits.results.queryType;
				uiState[useReactiveSearchCreds().reactiveBaseAppName].processingTime =
					instantSearchInstance.renderState?.[useReactiveSearchCreds().reactiveBaseAppName].hits.results.processingTimeMS;
			}
			// return sendUiStateToSearchEvent(uiState[useReactiveSearchCreds().reactiveBaseAppName], useState("userProfile").value);
		},
		subscribe() {
			instantSearchInstance;
		},
	};
}

export const useEmosMarker = (marker: { name: string, content: string }) => {
	try {
		onNuxtReady(() => {
			console.debug('sending marker', marker)
			try {
				useNuxtApp()?.$emos3?.send({
					'marker': marker?.name,
					'content': marker?.content
				})
			} catch (error) {
				console.error('not send marker', error);
			}
		})
	} catch (error) {
		console.error('could not send marker', error);
	}
}

export const useMarker = (marker: string) => {
	let markerStrings = useNuxtApp()?.$openfeature?.getContext().markers || "";
	const lastMarkers = markerStrings?.toString().split('|');
	if (lastMarkers.length > 4) {
		lastMarkers.shift();
	}
	lastMarkers.push(marker);
	useLastActions()?.value?.push(marker);
	if (useActionHistory()?.value?.length > 4) {
		useActionHistory()?.value?.shift();
	}
	useActionHistory()?.value?.push(marker);
	setABContextVariable('markers', lastMarkers?.join('|'));
}

export const useLastActions = () => useState<Array<string>>("lastActions", () => new Array<string>());
export const useActionHistory = () => useState<Array<string>>("actionHistory", () => new Array<string>());

export const useTrickOnce = (eventType: string, json: any) => {
	onConsented(() => {
		if (useCurrentSessionIdentifier().value) {
			useGeneralTrick({
				eventType: eventType,
				sessionId: useCurrentSessionIdentifier()?.value,
				json: json,
			});
		}
	})
}

export function createGeneralTickingData(event: any, to?: any) {

	const emos_jcvid = (import.meta.client ? localStorage.getItem("emos_jcvid") : undefined) || useCookie('emos-visitor').value;
	const emos_jcsid = (import.meta.client ? localStorage.getItem("emos_jcsid") : undefined) || (import.meta.client ? sessionStorage.getItem("emos_jcsid") : undefined) || useCookie('emos-visitor').value;
	const emos_privacy = import.meta.client ? localStorage.getItem("emos_privacy") : undefined
	const emos_jckamp = useCookie("emos_jckamp").value || (import.meta.client ? localStorage.getItem("emos_jckamp") : undefined);
	const _ga = useCookie("_ga").value;

	// const traits = {...useABConfigCookie()?.value};
	const states = createFlagState();
	let genericData = {
		tickId: uuidv4(),
		tickTs: Date.now(),
		storeId: useCurrentStore()?.value?.id,
		companyGroup: useCurrentStore()?.value?.companyGroupId,
		userAgent: useDevice()?.userAgent,
		url: to?.fullPath || (import.meta.client ? window.location.pathname + window.location.search + window.location.hash : useRoute().fullPath),
		route: { ...to, matched: undefined },
		emosVid: emos_jcvid,
		emosSid: emos_jcsid,
		emosPrv: emos_privacy,
		emosKmp: emos_jckamp,
		gaId: _ga,
		gaState: useGA4State()?.value,
		flagStates: states,
		// traits: traits,
	};

	const finalEvent = { ...genericData, ...event };
	// console.debug('ticking', finalEvent)
	return finalEvent;
}

function createFlagState() {
	let res: any = {}
	try {
		useFlagsUsedState().value.forEach(ent => {
			res[ent] = { enabled: useNuxtApp()?.payload.state['$sfeature-' + ent], value: useNuxtApp()?.payload.state['$sfeature-value-' + ent], variant: useFlagVariants()?.value?.get(ent) ?? 'default' }
		});
	} catch (error) {

	}
	return res;
}

export const toBase64 = (value: any) => {
	if (import.meta.client)
		return encodeURIComponent(btoa(JSON.stringify(value)))
	else
		return encodeURIComponent(Buffer.from(JSON.stringify(value), 'ascii').toString('base64'))
}

export const fromBase64 = (value: string) => {
	if (import.meta.client)
		return JSON.parse(atob(decodeURIComponent(value)))
	else
		return JSON.parse(Buffer.from(decodeURIComponent(value), 'base64').toString('ascii'))
}

export const toTickingPixel = (event: any) => {
	return `${useRuntimeConfig()?.public?.apiUrl}/api/generalTrick/tick.png?tdata=${toBase64(event)}`
}

// export function gtag() {
// 	useGtm()?.dataLayer().push(arguments);
// }
export function changeRouter() {
  console.debug("changeRouter : ",useRoute())
  useLastNavigationPoint().value = useRoute().path
}